import API from 'utils/api';

const baseURI = 'configuraciones/reportes-config/';

/**
 * Obtiene la lista de reportes activos.
 * @param {string} [pageKey] - Si se proporciona, filtra por page_key.
 * @returns {Promise<Array>}
 */
export const getReportesConfig = async (pageKey) => {
  const params = pageKey ? { page_key: pageKey } : {};
  const { data } = await API.get(baseURI, { params });
  return data;
};

export default getReportesConfig;
